import { RegistryInterface } from "./types";

export class Registry<T> implements RegistryInterface<T> {
  public registry: { [key: string]: T } = {};

  get(key: string): T {
    if (!this.has(key)) {
      throw new Error("error.key-not-exist: " + key);
    }
    return this.registry[key];
  }

  register(key: string, entry: T): void {
    if (this.has(key)) {
      throw new Error("error.key-already-exists");
    }
    this.registry[key] = entry;
  }

  has(key: string): boolean {
    if (this.registry[key]) {
      return true;
    }
    return false;
  }

  set(key: string, entry: T): void {
    if (!this.has(key)) {
      throw new Error("error.key-not-found");
    }
    this.registry[key] = entry;
  }

  clear(): void {
    this.registry = {};
  }
}
